<template>
  <section class="index-box">
    <!-- <div @click="clickBtn">123</div> -->
    <!-- 浏览器限制有声音的视频自动播放,所以需要加上muted -->
    <!-- <div> -->
    <video
      v-show="false"
      src="https://images.jianshankeji.com/timepark/timeparkVideo.mp4"
      :class="['video', videoScale ? 'video-none' : '']"
      autoplay
      muted
      @ended="end"
    ></video>
    <!-- </div> -->
    <iframe
      v-if="true"
      class="iframe-box"
      src="https://zsparkweb.jianshankeji.com/quanjin"
      frameborder="0"
    ></iframe>
    <bottomNav></bottomNav>
  </section>
</template>

<script>
export default {
  data() {
    return {
      showVideo: true,
      videoScale: false,
    };
  },

  components: {},

  mounted() {
    setTimeout(() => {
      this.videoScale = true;
    }, 8000);
    setTimeout(() => {
      this.showVideo = false;
    }, 8800);
  },

  methods: {
    clickBtn() {
      let ceshi = 123;
      let name = `O'MALL华侨城商业中心`;
      let address = "华侨城商业中心";
      // wx.miniProgram.redirectTo({
      //   url: `/pages/default/communication/main?type=address&lat=${31.093814}&lon=${121.503939}&name=${name}&address=${address}`, // 小程序中页面的路径
      // });
      wx.miniProgram.redirectTo({
        url: `/pages/default/communication/main?type=phone&num=${123456789}`, // 小程序中页面的路径
      });
      // wx.getLocation({
      //   type: "wgs84",
      //   success: function (res) {
      //     alert('123')
      //     wx.openLocation({
      //       //​使用微信内置地图查看位置。
      //       latitude: 31.093814, //要去的纬度-地址
      //       longitude: 121.503939, //要去的经度-地址
      //       name: "O'MALL华侨城商业中心",
      //       address: "华侨城商业中心",
      //     });
      //   },
      // });
      console.log("wx", wx);
    },
    end(e) {
      console.log("播放完成", e);
      this.showVideo = true;
    },
  },
};
</script>
<style lang='scss' scoped>
.index-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  .iframe-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
  }
  .video {
    width: 100%;
    height: 100vh;
    object-fit: fill; //一般用于img和video标签铺满
    transition: all 2s;
    // video {
    //   width: 100%;
    //   height: 100%;
    // }
  }
  .video-none {
    // width: 80%;
    // height: 80%;
    border-radius: 100%;
    transform: scale(0.6);
    opacity: 0.2;
  }
}
</style>